import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/http/base-http.service';
import { ProjectStage } from '@shared/enums/project-stage.enum';
import { ProjectLostStageReason } from '@shared/enums/project-lost-stage-reason.enum';
import { Config } from '@shared/configs/config';
import { catchError, EMPTY, Observable, tap, throwError } from 'rxjs';
import {
  IProjectStage,
  IProjectStagePayload
} from '@modules/projects/shared/interfaces/project-stage.interface';
import { Project } from '@modules/projects/shared/models/project.model';

@Injectable({ providedIn: 'root' })
export class ProjectStageAPIService extends BaseHttpService {
  constructor() {
    super();
  }

  setStage(
    projectId: number,
    stage: ProjectStage,
    reason?: { failureNote: string; failureReason: ProjectLostStageReason },
    termStart?: string,
    termEnd?: string,
    termChangeComment?: string,
    calculateStageDates?: boolean
  ): Observable<Project> {
    const url = `${Config.API}/project/${projectId}/stage`;

    const body = {
      stage,
      termStart,
      termEnd,
      termChangeComment,
      calculateStageDates,
      ...reason
    };

    return this.post(url, body, false, false).pipe(
      tap(() => this.s.success(this.t.instant('ProjectsTimeline.V2.successProjectTimerangeChanged'))),
      catchError((err) => {
        this.s.error(this.t.instant('ProjectsTimeline.V2.errorProjectTimerangeChanged'));
        return throwError(() => err);
      })
    ) as Observable<Project>;
  }

  setProjectStage(payload: IProjectStagePayload): Observable<Project> {
    const url = `${Config.API}/project/${payload.projectId}/stage`;

    return this.post(url, payload).pipe(
      tap(() => this.s.success(this.t.instant('ProjectsTimeline.V2.successProjectTimerangeChanged'))),
      catchError(() => {
        this.s.error(this.t.instant('ProjectsTimeline.V2.errorProjectTimerangeChanged'));
        return EMPTY;
      })
    );
  }

  clearStageNotification(projectId: number) {
    const url = `${Config.API}/project/${projectId}/clear-stage-notification`;
    return this.post(url, {});
  }

  sendStageNotification(projectId: number, content: string) {
    const url = `${Config.API}/project/${projectId}/send-stage-notification`;
    return this.post(url, { content });
  }

  getStages(params: Record<string, any> = {}): Observable<IProjectStage[]> {
    const url = `${Config.API}/project/stage`;
    return this.get(url, false, params);
  }
}
